import { Navigate, Route, Routes } from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";
import "./App.css";
import Login from "./pages/auth/login";
import Dashboard from "./pages/dashboard/index";
import LoginSalesForceAuthCallback from "./stories/auth/login-box/auth-login-with-sf-callback";
import Layout from "./pages/layout";
import PropertyList from "./pages/property/property-list";
import Profile from "./pages/profile";
import ProtectedRoute from "./hooks/context/useProtectedRoute";
import PrivateRoute from "./hooks/context/usePrivateRoute";
import FlipperVault from "./pages/flipper-vault";
import PropertyDetailMain from "./pages/property/property-details/property-detail-main";
import Investors from "./pages/investors-dashboard";
import InvestorPrivateRoute from "./hooks/context/useInvestorPrivateRoute";
import InvestorDetails from "./pages/investor/details";
import InvestorProtectedRoute from "./hooks/context/useInvestorProtectedRoute";
import InvestorLogin from "./pages/investor/login";
import InvestorOTPPrivateRoute from "./hooks/context/useInvestorOTPPrivateRoute";
import OtpVerification from "./pages/investor/otp-verification";
import PrivateInvExchange from "./hooks/context/useProtectedInvExchange";
import InvestorActivityWebPage from "./pages/invesetor-activity/page";
import PropertiesListing from "./pages/investor/properties-listing";
import InvestorDashboard from "./pages/investor/investor-dashboard";
import CallingPipeline from "./pages/calling-pipeline";

function App() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" />}></Route>
      <Route path="/" element={<ProtectedRoute Component={Login} />} />
      <Route
        path="/auth-login-with-sf-callback"
        element={<ProtectedRoute Component={LoginSalesForceAuthCallback} />}
      />
      <Route element={<PrivateRoute Component={Layout} />}>
        <Route
          path="/dashboard"
          element={<PrivateRoute Component={Dashboard} />}
        />
        <Route
          path="/properties"
          element={<PrivateRoute Component={PropertyList} />}
        />
        <Route
          path="/internal/:propertyId"
          element={<PrivateRoute Component={PropertyDetailMain} />}
        />
        <Route path="/profile" element={<PrivateRoute Component={Profile} />} />
        <Route
          path="/inv-list"
          element={<PrivateInvExchange Component={Investors} />}
        />
        <Route
          path="/calling-pipeline"
          element={<PrivateRoute Component={CallingPipeline} />}
        />
        <Route
          path="/flipper-vault"
          element={<PrivateInvExchange Component={FlipperVault} />}
        />
        <Route
          path="/inv-activity"
          element={<PrivateInvExchange Component={InvestorActivityWebPage} />}
        />
      </Route>
      <Route
        path="/investor-login"
        element={<InvestorProtectedRoute Component={InvestorLogin} />}
      />
      <Route
        path="/investor-otp-verification"
        element={<InvestorOTPPrivateRoute Component={OtpVerification} />}
      />
      <Route element={<Layout type="investor" />}>
        <Route
          path="/external/:propertyId"
          element={<InvestorPrivateRoute Component={InvestorDetails} />}
        />
        <Route
          path="/investor/properties-listing"
          element={<InvestorPrivateRoute Component={PropertiesListing} />}
        />
        <Route
          path="/investor/dashboard"
          element={<InvestorPrivateRoute Component={InvestorDashboard} />}
        />
      </Route>
    </Routes>
  );
}

export default App;
